const VENDOR_PARAM = 'vendor'

/**
 * The vendor a partner referral link attributes a signup to. Widget
 * deployments Paytrie hosts for a partner need nothing here: the API
 * recognises them by their origin.
 */
export const resolveSignupVendorId = (): string | undefined => {
  try {
    return (
      new URLSearchParams(window.location.search).get(VENDOR_PARAM) || undefined
    )
  } catch {
    return undefined
  }
}
